import { render, staticRenderFns } from "./LandingpageIllustration.vue?vue&type=template&id=3913cab4&scoped=true"
import script from "./LandingpageIllustration.vue?vue&type=script&lang=ts"
export * from "./LandingpageIllustration.vue?vue&type=script&lang=ts"
import style0 from "./LandingpageIllustration.vue?vue&type=style&index=0&id=3913cab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913cab4",
  null
  
)

export default component.exports